<div class="fleet-search-header" (click)="toggleFleetSearch()">
  <span class="fleet-search-title">Fleet search</span>
  <span class="fleet-search-desc">Search fleets by name or alliance ID</span>
  <span class="fleet-search-chevron">{{ fleetSearchOpen ? '▲' : '▼' }}</span>
</div>

<div class="fleet-fav-pills" *ngIf="favoriteFleets.length > 0">
  <button *ngFor="let fleet of favoriteFleets"
          class="fleet-fav-pill"
          [class.fleet-fav-pill-active]="fleet.allianceId === displayAllianceId"
          (click)="loadFleet(fleet.allianceId)">
    <span class="fleet-pill-star favorited"
          (click)="$event.stopPropagation(); toggleFavoriteFleet(fleet.allianceId, fleet.allianceName)"
          title="{{ isFavoriteFleet(fleet.allianceId) ? 'Unfavorite fleet' : 'Favorite fleet' }}">★</span>
    {{ fleet.allianceName }}
  </button>
</div>

<div class="fleet-search-panel" *ngIf="fleetSearchOpen || fleetSearchResults.length > 0 || fleetSearchError">
  <div class="fleet-search-row">
    <input #fleetSearchInput
           type="text"
           [(ngModel)]="fleetSearchTerm"
           placeholder="Search fleets by name…"
           class="fleet-search-input"
           (keydown.enter)="searchFleets()"
           autocomplete="off" />
    <button class="btn btn-ghost btn-sm" (click)="searchFleets()" [disabled]="fleetSearchLoading">
      <span *ngIf="!fleetSearchLoading">Search</span>
      <span *ngIf="fleetSearchLoading" class="spinner-tiny"></span>
    </button>
  </div>
  <div class="fleet-search-status" *ngIf="fleetSearchError">
    <span class="error-msg">{{ fleetSearchError }}</span>
  </div>
  <div class="fleet-search-results" *ngIf="fleetSearchResults.length > 0">
    <div class="fleet-search-result-row" *ngFor="let fleet of fleetSearchResults">
      <button class="fleet-result-star" [class.favorited]="isFavoriteFleet(fleet.allianceId)"
              (click)="toggleFavoriteFleet(fleet.allianceId, fleet.allianceName)" title="Favorite">★</button>
      <span class="fleet-result-name">{{ fleet.allianceName || 'Unknown fleet' }}</span>
      <span class="fleet-result-members" *ngIf="fleet.memberCount">{{ fleet.memberCount }} members</span>
      <span class="fleet-result-trophy" *ngIf="fleet.trophy">🏆 {{ fleet.trophy }}</span>
      <button class="btn btn-ghost btn-xs fleet-result-view" (click)="loadFleet(fleet.allianceId)">View</button>
    </div>
  </div>
</div>

<!-- Loading / error -->
<div class="tab-loading-area" *ngIf="fleetLoading">
  <div class="spinner-lg"></div>
  <span>Loading fleet data…</span>
</div>
<div class="error-msg" *ngIf="fleetError && !fleetLoading">{{ fleetError }}</div>


<!-- Fleet header -->
<div class="fleet-header" *ngIf="fleetInfo && !fleetLoading">
  <div class="fleet-name-block">
    <span class="fleet-title">{{ fleetInfo.allianceName }}</span>
    <button class="btn-icon btn-star" *ngIf="fleetInfo.allianceId"
            [class.favorited]="isFavoriteFleet(fleetInfo.allianceId)"
            (click)="toggleFavoriteFleet(fleetInfo.allianceId, fleetInfo.allianceName)"
            [title]="isFavoriteFleet(fleetInfo.allianceId) ? 'Unfavorite fleet' : 'Favorite fleet'">
      ★
    </button>
    <span class="fleet-division-badge" *ngIf="fleetInfo.divisionDesignId !== '0'">
      Div {{ divisionLabel(fleetInfo.divisionDesignId) }}
    </span>
    <button class="btn btn-warning btn-sm fleet-announce-btn" *ngIf="isViewingOwnFleet && isFleetOfficer && (fleetManagementEnabled || basicPlusEnabled)"
            (click)="openAnnouncementModal()">📢 Send fleet announcement</button>
  </div>
  <div class="fleet-meta-row">
    <span class="fleet-meta-cell">
      <span class="fleet-meta-icon">🏆</span>
      <span class="fleet-meta-val">{{ formatNumber(fleetInfo.trophy) }}</span>
      <span class="fleet-meta-key">Fleet Trophies</span>
    </span>
    <span class="fleet-meta-cell">
      <span class="fleet-meta-icon">👥</span>
      <span class="fleet-meta-val">{{ fleetInfo.memberCount }}</span>
      <span class="fleet-meta-key">Members</span>
    </span>
    <span class="fleet-meta-cell">
      <span class="fleet-meta-icon">⭐</span>
      <span class="fleet-meta-val">{{ fleetTotalStars }}</span>
      <span class="fleet-meta-key">Total Stars</span>
    </span>
    <span class="fleet-meta-cell" *ngIf="fleetPlacement">
      <span class="fleet-meta-icon">🏅</span>
      <span class="fleet-meta-val">#{{ fleetPlacement.rank }}</span>
      <span class="fleet-meta-key">Div {{ fleetPlacement.division }}{{ fleetPlacement.live ? '' : ' (prev)' }}</span>
    </span>
    <span class="fleet-meta-cell" *ngIf="fleetAttackStats">
      <span class="fleet-meta-icon">⚔️</span>
      <span class="fleet-meta-val">{{ fleetAttackStats.done }}/{{ fleetAttackStats.total }}</span>
      <span class="fleet-meta-key">Attacked</span>
    </span>
  </div>
  <div class="fleet-header-actions">
    <button class="btn btn-ghost fleet-refresh-btn" (click)="loadFleet()" [disabled]="fleetLoading">↻ Refresh</button>
  </div>
</div>

<!-- Private message panel -->
<div class="fleet-msg-panel" *ngIf="messagingMember && fleetSubView === 'current'">
  <div class="fleet-msg-header">
    Message <strong>{{ messagingMember.name }}</strong>
    <button class="btn btn-ghost btn-sm fleet-msg-close" (click)="messagingMemberId = null">✕</button>
  </div>
  <div class="fleet-msg-input-row">
    <input type="text" [(ngModel)]="privateMessageInput"
           (keydown.enter)="sendPrivateMessageAction(messagingMember)"
           placeholder="Type a message…"
           maxlength="500"
           [disabled]="privateMessageSending || !fleetManagementEnabled" />
    <button class="btn btn-primary btn-sm" (click)="sendPrivateMessageAction(messagingMember)"
            [disabled]="!fleetManagementEnabled || !privateMessageInput.trim() || privateMessageSending"
            [title]="fleetManagementEnabled ? '' : fleetManagementDisabledTooltip">
      {{ privateMessageSending ? '…' : 'Send' }}
    </button>
  </div>
  <div class="error-msg" *ngIf="privateMessageError">{{ privateMessageError }}</div>
</div>

<!-- Sub-view toggle: Current / History -->
<div class="fleet-sub-nav" *ngIf="fleetInfo && !fleetLoading">
  <button class="view-btn" [class.active]="fleetSubView === 'current'" (click)="fleetSubView = 'current'; selectedSnapshot = null">Current</button>
  <button class="view-btn" [class.active]="fleetSubView === 'history'" (click)="fleetSubView = 'history'">
    History <span class="tab-badge">{{ fleetSnapshots.length }}</span>
  </button>
</div>

<!-- History: snapshot list -->
<ng-container *ngIf="fleetSubView === 'history' && fleetInfo && !fleetLoading">
  <div class="fleet-snapshot-list" *ngIf="fleetSnapshots.length > 0; else noSnapshots">
    <button class="fleet-snapshot-btn" [class.active]="!selectedSnapshot" (click)="selectSnapshot(null)">Latest (live)</button>
    <button class="fleet-snapshot-btn"
            *ngFor="let s of fleetSnapshots"
            [class.active]="selectedSnapshot === s"
            (click)="selectSnapshot(s)">
      {{ snapshotLabel(s) }}
    </button>
  </div>
  <ng-template #noSnapshots>
    <div class="ai-empty">No historical snapshots yet. Snapshots are saved automatically each day you view this tab.</div>
  </ng-template>
  <div class="fleet-snapshot-info" *ngIf="selectedSnapshot">
    Showing snapshot from {{ snapshotLabel(selectedSnapshot) }} &nbsp;·&nbsp;
    {{ selectedSnapshot.allianceName }} &nbsp;·&nbsp;
    Div {{ divisionLabel(selectedSnapshot.divisionDesignId) }}
  </div>
</ng-container>

<!-- Applicants (Candidates) -->
<ng-container *ngIf="fleetInfo && !fleetLoading && isViewingOwnFleet && (fleetSubView === 'current' || selectedSnapshot) && fleetCandidates.length > 0">
  <div class="fleet-candidates-toggle" (click)="showCandidates = !showCandidates">
    <span class="fleet-candidates-title">
      <span class="fleet-candidate-dot"></span>
      Applicants <span class="fleet-candidates-count">{{ fleetCandidates.length }}</span>
    </span>
    <span class="toggle-arrow">{{ showCandidates ? '▲' : '▼' }}</span>
  </div>
  <div class="fleet-candidates-list" *ngIf="showCandidates">
    <div class="fleet-candidate-row"
         *ngFor="let m of fleetCandidates"
         [class.fleet-row-me]="m.userId === session!.userId">
      <span class="fleet-candidate-name">
        {{ m.name }}
        <span class="fleet-me-tag" *ngIf="m.userId === session!.userId">you</span>
      </span>
      <span class="fleet-candidate-trophy">🏆 {{ formatNumber(m.trophies) }}</span>
      <span class="fleet-candidate-actions" *ngIf="fleetSubView === 'current'">
        <span class="member-feedback success" *ngIf="memberSuccess.get(m.userId)">{{ memberSuccess.get(m.userId) }}</span>
        <span class="member-feedback error" *ngIf="memberError.get(m.userId)" [title]="memberError.get(m.userId)">!</span>
        <span class="member-busy" *ngIf="memberBusy.get(m.userId)">…</span>
        <ng-container *ngIf="!memberBusy.get(m.userId)">
            <button class="btn-icon"
                    [disabled]="fleetManagementLocked || !canPromoteMember(m)"
                    [title]="fleetManagementLocked ? fleetManagementDisabledTooltip : (canPromoteMember(m) ? 'Promote to ' + nextRankUp(m.allianceMembership) : 'Cannot promote')"
                    (click)="promoteMember(m)">↑</button>
            <button class="btn-icon btn-icon-danger"
                    [disabled]="fleetManagementLocked || !canPerformFleetMgmtOnMember(m)"
                    [title]="fleetManagementLocked ? fleetManagementDisabledTooltip : 'Kick ' + m.name"
                    (click)="kickMember(m)">✕</button>
          <button class="btn-icon"
                  [class.btn-icon-hidden]="m.userId === session!.userId || pendingFriendIds.has(m.userId)"
                  [disabled]="fleetManagementLocked"
                  [title]="fleetManagementLocked ? fleetManagementDisabledTooltip : (friendIds.has(m.userId) ? 'Send Message' : 'Add Friend')"
                  (click)="fleetManagementLocked ? null : (friendIds.has(m.userId) ? openMessagePanel(m) : addFriendAction(m))"
                  [class.active]="messagingMemberId === m.userId">
            {{ friendIds.has(m.userId) ? '✉' : '+' }}
          </button>
        </ng-container>
      </span>
    </div>
  </div>
</ng-container>

<!-- Fleet filter + export bar -->
<div class="fleet-filter-bar" *ngIf="fleetInfo && !fleetLoading">
  <div class="fleet-filter-group fleet-filter-name-group">
    <label class="fleet-filter-label">🔍</label>
    <input class="fleet-filter-input fleet-filter-name-input" type="text"
           placeholder="Search member name…"
           [(ngModel)]="fleetFilterName"
           autocomplete="off">
  </div>
  <div class="fleet-filter-group">
    <label class="fleet-filter-label">🏆</label>
    <input class="fleet-filter-input" type="number" min="0" placeholder="Min" [(ngModel)]="fleetFilterMinTrophies">
    <span class="fleet-filter-sep">–</span>
    <input class="fleet-filter-input" type="number" min="0" placeholder="Max" [(ngModel)]="fleetFilterMaxTrophies">
  </div>
  <div class="fleet-filter-group">
    <label class="fleet-filter-label">⭐</label>
    <input class="fleet-filter-input" type="number" min="0" placeholder="Min" [(ngModel)]="fleetFilterMinStars">
    <span class="fleet-filter-sep">–</span>
    <input class="fleet-filter-input" type="number" min="0" placeholder="Max" [(ngModel)]="fleetFilterMaxStars">
  </div>
  <div class="fleet-filter-group">
    <label class="fleet-filter-label">Att</label>
    <input class="fleet-filter-input" type="number" min="0" placeholder="Min" [(ngModel)]="fleetFilterMinAttacks">
    <span class="fleet-filter-sep">–</span>
    <input class="fleet-filter-input" type="number" min="0" placeholder="Max" [(ngModel)]="fleetFilterMaxAttacks">
  </div>
  <button class="btn btn-ghost btn-sm" title="Clear filters"
          *ngIf="fleetFilterName || fleetFilterMinTrophies || fleetFilterMaxTrophies || fleetFilterMinStars || fleetFilterMaxStars || fleetFilterMinAttacks || fleetFilterMaxAttacks"
          (click)="fleetFilterName=''; fleetFilterMinTrophies=''; fleetFilterMaxTrophies=''; fleetFilterMinStars=''; fleetFilterMaxStars=''; fleetFilterMinAttacks=''; fleetFilterMaxAttacks=''">✕</button>
  <button class="btn btn-ghost btn-sm fleet-export-btn" title="Export filtered list to CSV" (click)="exportFleetCsv()">⬇ CSV</button>
</div>

<!-- Member roster table -->
<div class="fleet-table" [class.fleet-with-actions]="fleetSubView === 'current'"
     *ngIf="fleetInfo && !fleetLoading && (fleetSubView === 'current' || selectedSnapshot)">
  <div class="fleet-table-header">
    <span class="ft-col-rank sort-col" (click)="setFleetSort('rank')">
      Rank<span class="sort-ind">{{ fleetSortBy === 'rank' ? (fleetSortAsc ? ' ↑' : ' ↓') : '' }}</span>
    </span>
    <span class="ft-col-name sort-col" (click)="setFleetSort('name')">
      Name<span class="sort-ind">{{ fleetSortBy === 'name' ? (fleetSortAsc ? ' ↑' : ' ↓') : '' }}</span>
    </span>
    <span class="ft-col-trophy sort-col" (click)="setFleetSort('trophies')">
      🏆<span class="sort-ind">{{ fleetSortBy === 'trophies' ? (fleetSortAsc ? ' ↑' : ' ↓') : '' }}</span>
    </span>
    <span class="ft-col-stars sort-col" (click)="setFleetSort('stars')">
      ⭐<span class="sort-ind">{{ fleetSortBy === 'stars' ? (fleetSortAsc ? ' ↑' : ' ↓') : '' }}</span>
    </span>
    <span class="ft-col-donated">Donated</span>
    <span class="ft-col-attacks sort-col" (click)="setFleetSort('attacks')">
      Attacks<span class="sort-ind">{{ fleetSortBy === 'attacks' ? (fleetSortAsc ? ' ↑' : ' ↓') : '' }}</span>
    </span>
    <span class="ft-col-login">Login</span>
    <span class="ft-col-actions" *ngIf="fleetSubView === 'current' && isViewingOwnFleet"></span>
  </div>
  <ng-container *ngFor="let m of sortedFleetMembers">
    <div class="fleet-row"
         [class.fleet-row-me]="m.userId === session!.userId"
         [class.fleet-row-promoted]="memberHighlight.get(m.userId) === 'promoted'"
         [class.fleet-row-demoted]="memberHighlight.get(m.userId) === 'demoted'">
      <span class="ft-col-rank">
        <span class="fleet-rank-badge rank-{{ m.allianceMembership | lowercase }}">{{ memberRankAbbr(m.allianceMembership) }}</span>
      </span>
      <span class="ft-col-name">
        {{ m.name }}
        <span class="fleet-me-tag" *ngIf="m.userId === session!.userId">you</span>
      </span>
      <span class="ft-col-trophy">{{ formatNumber(m.trophies) }}</span>
      <span class="ft-col-stars">{{ memberStarLabel(m) }}</span>
      <span class="ft-col-donated">{{ m.crewDonated }}</span>
      <span class="ft-col-attacks"
            [class]="tournAttemptClass(m.tournamentBonusScore)"
            [title]="'Today: ' + m.tournamentBonusScore + '/' + TOURN_DAILY_LIMIT + ' | Total: ' + tournAccumulatedAttacks(m.userId) + '/' + tournAccumulatedMax(m.userId)">
        {{ m.tournamentBonusScore }}/{{ TOURN_DAILY_LIMIT }}
        <span *ngIf="tournAccumulatedMax(m.userId) > 0" class="ft-attacks-total" [class]="tournAccumulatedClass(m.userId)">
          {{ tournAccumulatedAttacks(m.userId) }}/{{ tournAccumulatedMax(m.userId) }}
        </span>
      </span>
      <span class="ft-col-login" [class]="memberLastLoginClass(m.lastLoginDate)" [title]="formatDate(m.lastLoginDate)">
        {{ memberLastLoginLabel(m.lastLoginDate) }}
      </span>
      <span class="ft-col-actions" *ngIf="fleetSubView === 'current' && isViewingOwnFleet" (click)="$event.stopPropagation()">
        <span class="member-feedback success" *ngIf="memberSuccess.get(m.userId)">{{ memberSuccess.get(m.userId) }}</span>
        <span class="member-feedback error" *ngIf="memberError.get(m.userId)" [title]="memberError.get(m.userId)">!</span>
        <span class="member-busy" *ngIf="memberBusy.get(m.userId)">…</span>
        <ng-container *ngIf="!memberBusy.get(m.userId)">
            <button class="btn-icon"
                    *ngIf="!fleetManagementLocked && canPromoteMember(m)"
                    [title]="'Promote to ' + nextRankUp(m.allianceMembership)"
                    (click)="promoteMember(m)">↑</button>
            <button class="btn-icon"
                    *ngIf="!fleetManagementLocked && canDemoteMember(m)"
                    [title]="'Demote to ' + nextRankDown(m.allianceMembership)"
                    (click)="demoteMember(m)">↓</button>
            <button class="btn-icon btn-icon-danger"
                    *ngIf="!fleetManagementLocked && canPerformFleetMgmtOnMember(m)"
                    [title]="'Kick ' + m.name"
                    (click)="kickMember(m)">✕</button>
          <button class="btn-icon"
                  [class.btn-icon-hidden]="m.userId === session!.userId || pendingFriendIds.has(m.userId)"
                  [disabled]="fleetManagementLocked"
                  [title]="fleetManagementLocked ? fleetManagementDisabledTooltip : (friendIds.has(m.userId) ? 'Send Message' : 'Add Friend')"
                  (click)="fleetManagementLocked ? null : (friendIds.has(m.userId) ? openMessagePanel(m) : addFriendAction(m))"
                  [class.active]="messagingMemberId === m.userId">
            {{ friendIds.has(m.userId) ? '✉' : '+' }}
          </button>
        </ng-container>
      </span>
    </div>
  </ng-container>
  <div class="fleet-empty" *ngIf="sortedFleetMembers.length === 0">No member data available.</div>
</div>

<!-- ── Fleet Announcement Modal ── -->
<div class="modal-overlay" *ngIf="showAnnouncementModal" (click)="showAnnouncementModal = false">
  <div class="modal-box announcement-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <span class="modal-title">📢 Fleet Announcement</span>
    </div>
    <div class="modal-body">
      <textarea class="announcement-textarea" [(ngModel)]="announcementInput"
                placeholder="Type your fleet announcement…" rows="4"
                maxlength="1000"></textarea>
      <label class="announcement-push-row">
        <input type="checkbox" [(ngModel)]="announcementPushNotification" />
        <span>Send push notification</span>
      </label>
      <div class="error-msg" *ngIf="announcementError">{{ announcementError }}</div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-ghost btn-sm" (click)="showAnnouncementModal = false">Cancel</button>
      <button class="btn btn-warning btn-sm" (click)="sendAnnouncement()"
              [disabled]="!announcementInput.trim() || announcementSending">
        {{ announcementSending ? 'Sending…' : 'Send Announcement' }}
      </button>
    </div>
  </div>
</div>
